import React, { useEffect } from "react";

//Import Breadcrumb
import Breadcrumbs from "../../../components/Common/Breadcrumb";

import { Card, CardBody, CardTitle, Col, Container, Row } from "reactstrap";

const IconFontawesome = () => {
  document.title = "Font Awesome Icons | Upzet - React Admin & Dashboard Template";


  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs title="Icons" breadcrumbItem="Font Awesome Icons" />

          <Row>
            <Col>
            <Card>
              <CardBody>
                <CardTitle>Documentação - Font Awesome 7</CardTitle>
                <a href="https://fontawesome.com/search?o=r" target="_blank" rel="noreferrer">https://fontawesome.com/</a>
              </CardBody>
            </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default IconFontawesome;
